/* eslint-disable @typescript-eslint/naming-convention */

// ---- 1. Real env vars ----
const REACT_APP_ENV: string = process.env.REACT_APP_ENV;
const REACT_APP_GATEWAY_URL: string = process.env.REACT_APP_GATEWAY_URL;
const REACT_APP_KEYCLOAK_REALM: string = process.env.REACT_APP_KEYCLOAK_REALM;
const REACT_APP_KEYCLOAK_URL: string = process.env.REACT_APP_KEYCLOAK_URL;
const REACT_APP_KEYCLOAK_CLIENT_ID: string =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const REACT_APP_SOCKET_URL: string = process.env.REACT_APP_SOCKET_URL;
const REACT_APP_RECON_URL: string = process.env.REACT_APP_RECON_URL;
const REACT_APP_FORM_BASE_URL: string = process.env.REACT_APP_FORM_BASE_URL;

// ---- 2. Service groups + module paths ----
const SERVICE = {
  USER: 'services/user/api/v1',
  PROGRAM: 'services/program/api/v1',
  DATA: 'services/data/api/v1',
  APP: 'services/app/api/v1',
  COMMUNICATION: 'services/communication/api/v1',
  REDEEMHUB: 'services/redeemhub/api/v1',
};

const MODULE = {
  FILE_UPLOAD_MANAGEMENT: 'file_upload_management',
  PAYMENT_MANAGEMENT: 'payment_management',
  ORGANIZATION: 'organization',
  ROLES_PERMISSIONS: 'roles_permissions',
  INPUT_SOURCE: 'input_source',
  FREQUENCY_MANAGEMENT: 'frequency_management',
  WORKFLOW_MANAGEMENT: 'workflow_management',
  PROGRAM_CONFIGURATION_MANAGEMENT: 'program_configuration_management',
  UNIFIED_DATA_SOURCE: 'unified_data_source',
  MASTER_DATA_MANAGEMENT: 'master_data_management',
  USER_MANAGEMENT: 'user_management',
  MY_TASK: 'my_task',
  RULE_MANAGEMENT: 'rule_management',
  SIMULATION_MANAGEMENT: 'simulation_management',
  REPORTS_DOCUMENTS: 'reports_documents',
  DASHBOARD_MANAGEMENT: 'dashboard_management',
  TARGET_MANAGEMENT: 'target_management',
  CLAWBACK: 'clawback',
  QC_ORDER_API: 'qc_order_api',
  QC_API_FETCH_PRODUCT: 'qc_api_fetch_product',
  HOLD_RELEASE_DETAILS: 'hold_release_details',
  CONTEST_MANAGEMENT: 'contest_management',
  COMMUNICATION_MANAGEMENT: 'communication_management',
  NUDGE_MANAGEMENT: 'nudge_management',
  WALLET: 'wallet',
  VENDOR_MANAGEMENT: 'vendor_management',
  QUERY_MANAGEMENT: 'query_management',
  GRID_APPROVAL_WORKFLOW: 'grid_approval_workflow',
};

const buildUrl = (service: string, moduleName: string): string =>
  `${REACT_APP_GATEWAY_URL}/${service}/${moduleName}`;

// ---- 3. Final URLs ----
const REACT_APP_API_URL: string = buildUrl(
  SERVICE.DATA,
  MODULE.FILE_UPLOAD_MANAGEMENT
);
const REACT_APP_API_PAYOUT_URL: string = buildUrl(
  SERVICE.APP,
  MODULE.PAYMENT_MANAGEMENT
);
const REACT_APP_API_URL_ORG: string = buildUrl(
  SERVICE.USER,
  MODULE.ORGANIZATION
);
const REACT_APP_API_URL_ROLE_PERM: string = buildUrl(
  SERVICE.USER,
  MODULE.ROLES_PERMISSIONS
);
const REACT_APP_API_URL_INPUT_SOURCE: string = buildUrl(
  SERVICE.DATA,
  MODULE.INPUT_SOURCE
);
const REACT_APP_API_URL_FREQUENCY_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.FREQUENCY_MANAGEMENT
);
const REACT_APP_API_URL_WORKFLOW_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.WORKFLOW_MANAGEMENT
);
const REACT_APP_API_URL_PROGRAM: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.PROGRAM_CONFIGURATION_MANAGEMENT
);
const REACT_APP_API_URL_UNIFIED: string = buildUrl(
  SERVICE.DATA,
  MODULE.UNIFIED_DATA_SOURCE
);
const REACT_APP_API_URL_MASTER: string = buildUrl(
  SERVICE.DATA,
  MODULE.MASTER_DATA_MANAGEMENT
);
const REACT_APP_USER_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.USER_MANAGEMENT
);
const REACT_APP_MY_TASK_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.MY_TASK
);
const REACT_APP_API_URL_RULE: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.RULE_MANAGEMENT
);
const REACT_APP_API_URL_SIMULATION_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.SIMULATION_MANAGEMENT
);
const REACT_APP_API_URL_REPORT_MANAGEMENT: string = buildUrl(
  SERVICE.APP,
  MODULE.REPORTS_DOCUMENTS
);
const REACT_APP_API_URL_DASHBOARD_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.DASHBOARD_MANAGEMENT
);
const REACT_APP_API_URL_TARGET_MANAGEMENT: string = buildUrl(
  SERVICE.APP,
  MODULE.TARGET_MANAGEMENT
);
const REACT_APP_API_URL_CLAWBACK: string = buildUrl(
  SERVICE.DATA,
  MODULE.CLAWBACK
);
const REACT_APP_API_URL_ORDER_API: string = buildUrl(
  SERVICE.REDEEMHUB,
  MODULE.QC_ORDER_API
);
const REACT_APP_API_URL_QC_API: string = buildUrl(
  SERVICE.REDEEMHUB,
  MODULE.QC_API_FETCH_PRODUCT
);
const REACT_APP_API_URL_HOLD_RELEASE: string = buildUrl(
  SERVICE.APP,
  MODULE.HOLD_RELEASE_DETAILS
);
const REACT_APP_API_URL_CONTEST_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.CONTEST_MANAGEMENT
);
const REACT_APP_API_URL_COMMUNICATION_MANAGEMENT: string = buildUrl(
  SERVICE.COMMUNICATION,
  MODULE.COMMUNICATION_MANAGEMENT
);
const REACT_APP_API_URL_NUDGE_MANAGEMENT: string = buildUrl(
  SERVICE.COMMUNICATION,
  MODULE.NUDGE_MANAGEMENT
);
const REACT_APP_API_URL_WALLET: string = buildUrl(SERVICE.APP, MODULE.WALLET);
const REACT_APP_VENDOR_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.VENDOR_MANAGEMENT
);
const REACT_APP_API_URL_QUERY_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.QUERY_MANAGEMENT
);
const REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.GRID_APPROVAL_WORKFLOW
);

export {
  REACT_APP_ENV,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_API_PAYOUT_URL,
  REACT_APP_API_URL_ORG,
  REACT_APP_API_URL_ROLE_PERM,
  REACT_APP_API_URL_INPUT_SOURCE,
  REACT_APP_API_URL_FREQUENCY_MANAGEMENT,
  REACT_APP_API_URL_WORKFLOW_MANAGEMENT,
  REACT_APP_API_URL_UNIFIED,
  REACT_APP_API_URL_PROGRAM,
  REACT_APP_API_URL_MASTER,
  REACT_APP_USER_API_URL,
  REACT_APP_MY_TASK_API_URL,
  REACT_APP_API_URL_RULE,
  REACT_APP_API_URL_SIMULATION_MANAGEMENT,
  REACT_APP_API_URL_REPORT_MANAGEMENT,
  REACT_APP_FORM_BASE_URL,
  REACT_APP_SOCKET_URL,
  REACT_APP_API_URL_DASHBOARD_MANAGEMENT,
  REACT_APP_API_URL_TARGET_MANAGEMENT,
  REACT_APP_API_URL_CLAWBACK,
  REACT_APP_API_URL_ORDER_API,
  REACT_APP_API_URL_QC_API,
  REACT_APP_API_URL_HOLD_RELEASE,
  REACT_APP_API_URL_CONTEST_MANAGEMENT,
  REACT_APP_API_URL_COMMUNICATION_MANAGEMENT,
  REACT_APP_API_URL_NUDGE_MANAGEMENT,
  REACT_APP_API_URL_WALLET,
  REACT_APP_VENDOR_API_URL,
  REACT_APP_API_URL_QUERY_MANAGEMENT,
  REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW,
  REACT_APP_RECON_URL,
};
